import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo4/syndi.png";
import Imagen2 from "../../../images/modulo4/marialuisa.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo4 } from "../../../routes/Module4";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo4/Actividad 6.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo4.content[0];
  const infoAct = modulo4.content[0].activities[5];
  const crumbs = [
    {
      title: modulo4.title,
      url: "/" + modulo4.url,
    },
    {
      title:
        modulo4.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo4.content[0].activities[6].name}`,
    linkNext: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[6].path}`,
    titlePrev: `${modulo4.content[0].activities[4].name}`,
    linkPrev: `${modulo4.url}/${modulo4.content[0].path}/${modulo4.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo4.color,
    title: `${modulo4.title} - ${infoAct.name}`,
    name: modulo4.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo4.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 6</h2>
      <AudioPlayer track={Audio} />

      <ul className="my-5">
        <li>
          Además del castellano, en el Perú se hablan muchas lenguas originarias
          como el quechua, el aimara o el awajún.
        </li>
        <li>
          Practica con un compañero, compañera o familiar este diálogo. Háganlo
          en español, quechua y aimara. Reemplacen los nombres de los personajes
          por los nombres de ustedes.
        </li>
      </ul>

      <div className="row my-3 align-items-center">
        <div className="col-lg-5 col-md-6 col-12">
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
        <div className="col-lg-5 col-md-6 col-xs-12">
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
      </div>

      <table className="table table-bordered mt-5">
        <thead>
          <tr>
            <th>Castellano</th>
            <th>Quechua</th>
            <th>Aimara</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>¿Cómo estás, …?</td>
            <td>¿Imaynalam kachkanki, …?</td>
            <td>¿Kamisaraki, …?</td>
          </tr>
          <tr>
            <td>Muy bien, …</td>
            <td>Allinmi kachkani, …</td>
            <td>Waliki, …</td>
          </tr>
          <tr>
            <td>Gracias, …</td>
            <td>Añachakuyki, …</td>
            <td>Paysuma, …</td>
          </tr>
          <tr>
            <td>De nada, …</td>
            <td>Manam imananpaschu, …</td>
            <td>Janiwa kunatsa, …</td>
          </tr>
        </tbody>
      </table>
      <p className="mt-4">
        <small>(Colaboración de Jainor Saavedra y Edgar Sanga)</small>
      </p>
      <ul className="my-5">
        <li>
          Ahora, conversen sobre lo siguiente. ¿Es bueno conocer las lenguas
          originarias del Perú? ¿Por qué?
        </li>
      </ul>

      <GuiaDocente>
        <p>
          Lea las indicaciones. Ayude a leer las expresiones en quechua y
          aimara y realicen los diálogos. Finalice conversando
          sobre la última pregunta y resaltando la importancia de las lenguas
          para la convivencia.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
